module.exports = __webpack_public_path__ + "media/images/flags/64/Moldova-b45ceb36472f283cd74cbe987149cb86.png";